import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "buildingsContent",
    "buildingsChevron",
    "actionPanel",
    "actionPanelContent",
    "actionPanelChevron"
  ]

  connect() {
    this.buildingsCollapsed = false
    this.actionPanelCollapsed = false
  }

  toggleBuildings() {
    this.buildingsCollapsed = !this.buildingsCollapsed
    this._applyLayout()
  }

  toggleActionPanel() {
    this.actionPanelCollapsed = !this.actionPanelCollapsed
    this._applyLayout()
  }

  _applyLayout() {
    const bc = this.buildingsContentTarget
    const bch = this.buildingsChevronTarget
    const ap = this.actionPanelTarget
    const apc = this.actionPanelContentTarget
    const apch = this.actionPanelChevronTarget
    const heightClasses = ["h-48", "sm:h-56", "lg:h-60", "xl:h-72"]

    bc.classList.toggle("hidden", this.buildingsCollapsed)
    bch.textContent = this.buildingsCollapsed ? "▲" : "▼"

    apc.classList.toggle("hidden", this.actionPanelCollapsed)
    apch.textContent = this.actionPanelCollapsed ? "▼" : "▲"

    // Expand action panel to fill screen only when buildings hidden and panel open
    const shouldExpand = this.buildingsCollapsed && !this.actionPanelCollapsed

    if (shouldExpand) {
      ap.classList.remove("shrink-0")
      ap.classList.add("flex-1", "flex", "flex-col", "min-h-0")
      heightClasses.forEach(c => apc.classList.remove(c))
      apc.classList.add("flex-1", "min-h-0")
    } else {
      ap.classList.add("shrink-0")
      ap.classList.remove("flex-1", "flex", "flex-col", "min-h-0")
      apc.classList.remove("flex-1", "min-h-0")
      if (!this.actionPanelCollapsed) {
        heightClasses.forEach(c => apc.classList.add(c))
      }
    }
  }
}
